import { addMinutes, parse } from 'date-fns';
import { fromZonedTime } from 'date-fns-tz';
import * as Sentry from '@sentry/browser';

/**
 * Ritorna un'oggetto Date shiftato
 * di un delta random di max +/-5 minuti
 *
 * @param string time Tempo del check, da intendersi come ora locale.
 * @param Date referenceDate oggetto Date per recuperare le info non presenti nella stringa time.
 *
 * @returns Date
 */
const getDeltaDate = (time, referenceDate) => {
  // Creo un oggetto Date che abbia l'orario del verifyTime
  const itaDate = parse(time, 'HH:mm', referenceDate);
  // La data creata è relativa al timezone italiano, la converto nel timezone locale
  let localDate = fromZonedTime(itaDate, 'Europe/Rome');
  let delta = Math.floor(Math.random() * 6);
  delta *= Math.round(Math.random()) ? 1 : -1;
  return addMinutes(localDate, delta);
};

const getVerifyTimes = (currentTime) => {
  if (
    !process.env.VERIFY_TIMES ||
    typeof process.env.VERIFY_TIMES !== 'string'
  ) {
    console.error('Verify times not set!');
    Sentry.captureException(new Error('verify times not set'));
  }
  const timesArray = process.env.VERIFY_TIMES.split(';');
  return timesArray.reduce((carry, check, index) => {
    carry[`check${index + 1}`] = getDeltaDate(check, currentTime);
    return carry;
  }, {});
};

export default { getVerifyTimes };
